import RestApiModel from "@/api/Model/RestApiModel";

class SubmitReferral extends RestApiModel {
  static getResourceEndpoint() {
    return '/SubmitReferral';
  }
}

export default SubmitReferral;
